var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"contraste",attrs:{"fab":"","small":"","dark":""},on:{"click":_vm.switchTheme}},[(_vm.$vuetify.theme.dark)?_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-brightness-7")]):_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-brightness-3")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }